import { render, staticRenderFns } from "./ShowBook.vue?vue&type=template&id=324ec0aa"
import script from "./ShowBook.vue?vue&type=script&lang=js"
export * from "./ShowBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports